export default __webpack_public_path__ + "static/media/som.96244840.mp3";